const initialState = {
  loading: false,
  submitting: false,
  successful: false,
  vehicles: [],
  vehicle: null,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_DOCUMENT_VEHICLES': {
      return {
        ...state,
        loading: true,
      }
    }

    case 'GET_DOCUMENT_VEHICLES_COMMIT': {
      return {
        ...state,
        loading: false,
        vehicles: action.payload.vehicles,
      }
    }

    case 'GET_DOCUMENT_VEHICLES_ROLLBACK': {
      return {
        ...state,
        loading: false,
        vehicles: [],
      }
    }

    case 'ADD_DOCUMENT_VEHICLE': {
      return {
        ...state,
        submitting: true,
        successful: false,
      }
    }

    case 'ADD_DOCUMENT_VEHICLE_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'ADD_DOCUMENT_VEHICLE_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
      }
    }

    case 'REMOVE_DOCUMENT_VEHICLE': {
      return {
        ...state,
        successful: false,
        submitting: true,
      }
    }

    case 'REMOVE_DOCUMENT_VEHICLE_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'REMOVE_DOCUMENT_VEHICLE_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
      }
    }

    case 'SET_DOCUMENT_VEHICLE': {
      return {
        ...state,
        vehicle: action.payload.vehicle,
      }
    }

    default: {
      return state
    }
  }
}
